import React, { useState } from 'react';
import styled from 'styled-components';
import Modal from '../../components/Modal';
import PropTypes from 'prop-types';

function FormSeleccionarND(props) {
    const {
        periodoL,
        listaEs
    } = props;

    const [id, setId] = useState("");
    const [idEst, setEst] = useState("");
    
    const handleChange = e => {
        localStorage.setItem('id_periodo', e.target.value);
        setId(e.target.value);
    }

    const handleChangeES = e => {
        localStorage.setItem('id_establecimiento', e.target.value);
        setEst(e.target.value);
    }

    const [estadoModal, cambiarEstadoModal] = useState(true);
    let ruta = window.location.href;
    let id_emp = ruta.split('/');
    return (
        <div className='container'>
            <Modal
                estado={estadoModal}
                cambiarEstado={cambiarEstadoModal}
                titulo="Seleccionar"
                botonCerrar="false"
            >
                {listaEs.length >=2 && 
                    <div className="form-floating mb-3">
                        <select className="form-select" id="establecimiento"
                            value={idEst} onChange={handleChangeES} >
                            <option selected>Seleccionar...</option>
                            {listaEs.map(mes =>
                                <option key={mes.value} value={mes.value}>{mes.label}</option>)
                            }

                        </select>
                        <label className='form-label' htmlfor="establecimiento">Establecimiento</label>
                    </div>
                }
                {((periodoL && idEst != '') || listaEs.length == 1) &&
                    <div className="form-floating">
                        <select className="form-select" id="periodo"
                            value={id} onChange={handleChange} >
                            <option selected>Seleccionar...</option>
                            {periodoL.map(mes =>
                                <option key={mes.value} value={mes.value}>{mes.label}</option>)
                            }

                        </select>
                        <label className='form-label' htmlfor="periodo">Periodo</label>
                    </div>
                }
                <br />
                <Contenido>
                    {periodoL.length > 0 &&
                        (id &&
                        <a
                            href={`/#/facturacion/${id_emp[5]}/nota_debito/${id}`}
                            className='btn mr-2 mb-3 btn-primary'
                        >
                            Seleccionar
                        </a>
                        )
                    }
                </Contenido>
            </Modal>
        </div>
    );

}
FormSeleccionarND.propTypes = {
    periodoL: PropTypes.string.isRequired,
    listaEs: PropTypes.string.isRequired
};

export default (FormSeleccionarND);

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;